<template>
  <div class="showcase card border-0 mb-5 pb-3">
    <div class="card-body p-0">
      <table class="table table-borderless table-sm">
        <tbody>
        <tr>
          <td width="1%" class="text-nowrap">Client:</td>
          <td v-html="termNames(showcase.client)" class="fw-bold"></td>
        </tr>
        <tr>
          <td class="text-nowrap">Sector:</td>
          <td v-html="termNames(showcase.sector)" class="fw-bold"></td>
        </tr>
        <tr>
          <td class="text-nowrap">Type of work:</td>
          <td v-html="termNames(showcase.type_of_work)" class="fw-bold"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="showcase__featured-image" v-html="featuredImage()" @click="openLightbox()" :class="{ 'has-gallery': hasGallery }"></div>
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/lightbox';

const leftArrowSVGString = '<svg width="80" height="80" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg>';
const rightArrowSVGString = '<svg width="80" height="80" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>';
const zoomSVGString = '<svg width="20" height="20" fill="currentColor" className="bi bi-zoom-in" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/></svg>';
const closeSVGString = '<svg width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>';

export default {
  props: [
    'showcase',
  ],
  data() {
    return {
      lightbox: false,
      hasGallery: false,
      media: []
    }
  },
  mounted() {
    for (let i in this.showcase.acf.gallery) {
      if (this.showcase.acf.gallery[i].acf_fc_layout === 'image') {
        this.media.push(this.showcase.acf.gallery[i].attachment);
      }
      else if (this.showcase.acf.gallery[i].acf_fc_layout === 'video') {
        this.media.push({
          html: this.showcase.acf.gallery[i].attachment.embed
        })
      }
    }
    if (this.media.length) {
      this.hasGallery = true;
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
  methods: {
    openLightbox() {
      if (!this.hasGallery) {
        return;
      }
      if (!this.lightbox) {
        this.initLightbox();
      }
      this.lightbox.loadAndOpen(0);
    },
    initLightbox() {
      const lightbox = new PhotoSwipeLightbox({
        padding: { top: 150, bottom: 150, left: 150, right: 150 },
        paddingFn: (viewportSize, itemData, index) => {
          return {
            top: viewportSize.x < 600 ? 20 : 150,
            bottom: viewportSize.x < 600 ? 20 : 150,
            left: viewportSize.x < 600 ? 20 : 150,
            right: viewportSize.x < 600 ? 20 : 150,
          };
        },
        bgOpacity: 1,
        dataSource: this.media,
        pswpModule: () => import('photoswipe'),
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        zoomSVG: zoomSVGString,
        closeSVG: closeSVGString,
        arrowPrev: window.innerWidth >= 600,
        arrowNext: window.innerWidth >= 600
      });
      lightbox.init();
      lightbox.on('change', function(e, f) {
        lightbox.pswp.container.querySelectorAll('video').forEach(function(video) {
          video.pause();
        });
      });
      this.lightbox = lightbox;
    },
    termNames(terms) {
      let termNames = [];
      for (let i in this.showcase['_embedded']['wp:term']) {
        let tax_terms = this.showcase['_embedded']['wp:term'][i];
        for (let j in tax_terms) {
          if (terms.includes(tax_terms[j].id)) {
            termNames.push(tax_terms[j].name);
          }
        }
      }
      return termNames.join(', ');
    },
    featuredImage() {
      if (typeof this.showcase['_embedded']['wp:featuredmedia'] === "undefined") {
        return '<img src="https://via.placeholder.com/768x515.png?text=Featured+image+placeholder" class="img-fluid">';
      }
      else {
        for (let i in this.showcase['_embedded']['wp:featuredmedia']) {
          let media = this.showcase['_embedded']['wp:featuredmedia'][i];
          let img = media.media_details.sizes['showcase-shallow'];
          return '<img src="' + img.source_url + '" width="' + img.width + '" height="' + img.height + '" alt="' + media.alt_text + '" class="img-fluid">';
        }
      }

    }
  }
}
</script>
